<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Education Institutes"
      text="Edit Education Institute"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localEducationInstitution.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name" 
                outlined               
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localEducationInstitution.country_id"
                v-validate="'required'"
                :error-messages="errors.collect('country')"
                data-vv-name="country"  
                outlined        
                :items="countries"
                item-text="name"
                item-value="id"
                label="Country"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"       
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="px-10 white--text"       
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      educationInstitution: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localEducationInstitution: null,
        countries: [],
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.loadCountries()
        this.localEducationInstitution = { ...this.educationInstitution }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.hrisEducationInstitutes().update(this.educationInstitution.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.progressing = false
                  this.dialog = false
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          name: this.localEducationInstitution.name,
          country_id: this.localEducationInstitution.country_id,
        }
      },
      loadCountries () {
        this.$api.countries().list()
          .then(res => {
            this.countries = _.orderBy(res.data, ['name'], ['asc'])
          })
      },
    },
  }
</script>
